import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// UI

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from '@chakra-ui/react'

//Hooks
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

// Custom
import useOffer from '@/features/offers/hooks/useOffer'
import useOfferApproval from '@/features/offers/hooks/useOfferApproval'
import { hideResubmitOfferModal } from '@/stores/offers/offersSlice'
import { selectResubmitOfferModal } from '@/stores/offers/resubmitOfferModalSlice'
import { camelToWords } from '@/utils/stringHelper'

const ResubmitOfferModal = () => {
  const { isOpened, offerStage, offerId, offerDetail } = useSelector(selectResubmitOfferModal)

  const dispatch = useDispatch()

  const { useResumeOfferQuotation, useResumeOfferBooking, useRestartOfferQuotation, useRestartOfferBooking } =
    useOfferApproval()

  const { useUpdateOffer } = useOffer()

  const resumeOfferQuotation = useResumeOfferQuotation()
  const restartOfferQuotation = useRestartOfferQuotation()
  const resumeOfferBooking = useResumeOfferBooking()
  const restartOfferBooking = useRestartOfferBooking()

  const updateOffer = useUpdateOffer()

  const remark = useRef()

  const closeModal = () => {
    dispatch(hideResubmitOfferModal())
  }

  const handleResubmit = async (stage, resubmitType) => {
    const remarkValue = remark.current.value

    try {
      dispatch(showLoadingOverlay())
      if (stage === 'quotation' && resubmitType === 'resume') {
        await resumeOfferQuotation.mutateAsync({
          offerId: offerId,
          offer: offerDetail,
          remark: remarkValue,
        })
      } else if (stage === 'quotation' && resubmitType === 'restart') {
        await restartOfferQuotation.mutateAsync({
          offerId: offerId,
          offer: offerDetail,
          remark: remarkValue,
        })
      } else if (stage === 'booking' && resubmitType === 'resume') {
        await updateOffer.mutateAsync({ id: offerId, data: offerDetail })

        await resumeOfferBooking.mutateAsync({
          offerId: offerId,
          offer: offerDetail,
          remark: remarkValue,
        })
      } else if (stage === 'booking' && resubmitType === 'restart') {
        await updateOffer.mutateAsync({ id: offerId, data: offerDetail })

        await restartOfferBooking.mutateAsync({
          offerId: offerId,
          offer: offerDetail,
          remark: remarkValue,
        })
      }

      closeModal()
    } catch (res) {
      console.log(res)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }
  return (
    <Modal isOpen={isOpened} onClose={closeModal} size="xl">
      <form onSubmit={(e) => e.preventDefault()}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Resubmit Offer {camelToWords(offerStage)}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>Remark for approver / contributor: </p>
            <Textarea name="remark" rows="5" ref={remark} />
            <Text as="i" color={'red.500'} fontSize="14px">
              * Restart will reset all approver status, all previous approved need to go through the workflow again
            </Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button colorScheme="green" onClick={() => handleResubmit(offerStage, 'resume')}>
                Resume
              </Button>
              <Button colorScheme="red" onClick={() => handleResubmit(offerStage, 'restart')}>
                Restart Approval
              </Button>
              <Button colorScheme="gray" onClick={closeModal}>
                Close
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  )
}

export default ResubmitOfferModal
